/**
 * 考试专属等级 extraFields（jlptLevel / topikLevel / …）与通用 Question.level 的别名关系。
 * 产线主写 `level`；专属字段可缺省，校验与入库时从 level 回填。
 */

export const EXAM_LEVEL_EXTRA_FIELD_BY_EXAM: Readonly<Record<string, string>> = {
  jlpt: 'jlptLevel',
  topik: 'topikLevel',
  dele: 'deleLevel',
  siele: 'sieleLevel',
};

export const EXAM_LEVEL_EXTRA_FIELD_IDS: ReadonlySet<string> = new Set(
  Object.values(EXAM_LEVEL_EXTRA_FIELD_BY_EXAM)
);

/** 缺专属等级字段时，用 question.level 参与校验。 */
export function resolveExamLevelFieldValue(
  fieldName: string,
  question: Record<string, unknown>
): unknown {
  const dedicated = question[fieldName];
  if (dedicated !== undefined && dedicated !== null && dedicated !== '') {
    return dedicated;
  }
  if (EXAM_LEVEL_EXTRA_FIELD_IDS.has(fieldName)) {
    return question.level;
  }
  return dedicated;
}

/** 按考试把通用 level 戳成专属字段（仅填缺省，不覆盖已有值）。 */
export function stampExamLevelExtraFields(input: {
  examType?: string;
  level?: string;
  existing?: Record<string, unknown>;
}): Record<string, string> {
  const exam = String(input.examType ?? '')
    .trim()
    .toLowerCase();
  const field = EXAM_LEVEL_EXTRA_FIELD_BY_EXAM[exam];
  const lev = typeof input.level === 'string' ? input.level.trim() : '';
  if (!field || !lev) return {};

  const existing = input.existing?.[field];
  if (typeof existing === 'string' && existing.trim()) {
    return { [field]: existing.trim() };
  }
  return { [field]: lev };
}
